import { useQuery } from "@tanstack/react-query";
import { hub } from "@/lib/hub-client";

export type TransactionKind =
  | "credit"
  | "debit"
  | "hold"
  | "capture"
  | "release"
  | "refund"
  | "expire"
  | "adjustment";

export interface TransactionRow {
  id: string;
  kind: TransactionKind;
  job_id: string | null;
  partner_id: string | null;
  metadata: Record<string, unknown> | null;
  created_at: string;
  available_delta: number;
  held_delta: number;
}

export interface TransactionList {
  items: TransactionRow[];
  next_cursor: string | null;
}

export function useTransactions() {
  return useQuery({
    queryKey: ["wallet", "transactions"],
    queryFn: async () => {
      const res = await hub.GET<TransactionList>("/v1/me/wallet/transactions", {
        params: { limit: "30" },
      });
      if (!res.data) throw new Error("transactions fetch failed");
      return res.data;
    },
  });
}
